import { render } from "./Info.vue?vue&type=template&id=2d767128"
const script = {}

import "./Info.vue?vue&type=style&index=0&id=2d767128&lang=scss"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__